import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Checkbox = ({
	arialLabel,
	checked,
	error,
	id,
	name,
	onBlur,
	onChange,
	onKeyUp,
	tabIndex,
	text
}) => (
	<div className={styles.Checkbox}>
		<input
			id={id}
			name={name || id}
			type="checkbox"
			className={styles.Checkbox__Input}
			checked={checked}
			onChange={onChange}
			onBlur={onBlur}
			tabIndex={tabIndex}
			aria-label={arialLabel}
			onKeyUp={onKeyUp}
		/>
		<label htmlFor={id} className={styles.Checkbox__Label}>
			<span className={styles.Checkbox__Figure}>
				<Icon icon="check" className={styles.Checkbox__Icon} />
			</span>
			<span className={styles.Checkbox__Text}>{text}</span>
		</label>
		{error && <div>{error}</div>}
	</div>
);

Checkbox.propTypes = {
	arialLabel: PropTypes.string,
	checked: PropTypes.bool,
	error: PropTypes.string,
	id: PropTypes.string.isRequired,
	name: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onKeyUp: PropTypes.func,
	tabIndex: PropTypes.number,
	text: PropTypes.node.isRequired
};

Checkbox.defaultProps = {
	checked: false
};

export default Checkbox;
